import React, {useRef, useEffect} from 'react';
import {
  View,
  Text,
  TextInput,
  ScrollView,
  ImageBackground,
  TouchableOpacity
} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import i18n from 'i18n-js';
import CommonStyles from '../../style/commonStyles';
import {setInput} from '../../actions/productFirstActions';
import useWidth from '../scanToCartScanning/useWidth';

const ScanLanding = ({caption, placeholder, onSubmit}) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const width = useWidth();
  const input = useSelector(state => state.productFirst.input);
  const mainInputHasFocus = useSelector(
    state => state.productFirst.mainInputHasFocus
  );

  useEffect(() => {
    if (mainInputHasFocus) {
      inputRef.current?.focus();
    }
  }, [mainInputHasFocus]);

  const submit = () => {
    if (input) {
      onSubmit();
    }
  };

  return (
    <ImageBackground
      style={{flex: 1}}
      source={require('../../../assets/background.png')}>
      <ScrollView
        contentContainerStyle={{flex: 1}}
        style={{position: 'relative'}}>
        <ImageBackground
          style={CommonStyles.quickScanImage}
          source={require('../../../assets/scaning.png')}
          resizeMode="contain">
          <Text style={[CommonStyles.ScanText, {lineHeight: width < 768 ? 55 : 90}]}>
            {i18n.t('scanPack.scanLabel')}
          </Text>

          <View
            style={[
              CommonStyles.searchContainer,
              {width: width > 900 ? '30%' : '95%'}
            ]}>
            <TextInput
              testID="putWallLandingInput"
              ref={inputRef}
              autoFocus
              value={input}
              placeholder={placeholder}
              onChangeText={text => dispatch(setInput(text))}
              onSubmitEditing={submit}
              style={CommonStyles.scanInput}
              autoCapitalize="none"
            />
            <TouchableOpacity
              testID="putWallLandingSearch"
              style={{paddingVertical: 4, paddingHorizontal: 5}}
              onPress={submit}>
              <i
                className="icon-search"
                style={{color: 'rgb(172,187,199)', fontSize: '23px'}}></i>
            </TouchableOpacity>
          </View>

          <Text style={[CommonStyles.lastImportTextOne, {marginTop: 0}]}>
            {caption}
          </Text>
        </ImageBackground>
      </ScrollView>
    </ImageBackground>
  );
};

export default ScanLanding;
